import { SalesStatistic as ApiSalesStatistic } from "randmar-api-client";
import { shortMonthNames } from "../components/util/DateTimeUtil";
import { SalesStatistics as LegacySalesStatistics } from "../stores/reseller/Reseller";


const isLegacySalesStatistic = (item: LegacySalesStatistics | ApiSalesStatistic): item is LegacySalesStatistics => 'day' in item;

const toApiSalesStatistic = (item: LegacySalesStatistics): ApiSalesStatistic => ({
  Day: item.day,
  Quantity: item.quantity,
  ExtendedPrice: item.extendedPrice
});

const getMonthYearKey = (date: Date) => {
  const month = shortMonthNames[date.getMonth()];
  const year = date.getFullYear().toString().slice(-2);
  return `${month} '${year}`;
};

export function groupSalesDataByMonth(data: (LegacySalesStatistics | ApiSalesStatistic)[], monthsBack: number) {
  const currentDate = new Date();
  // Set to the first day of the earliest month to create a correct date range and avoid day-of-month overflow issues.
  const monthsAgo = new Date(currentDate.getFullYear(), currentDate.getMonth() - (monthsBack - 1), 1);

  const lastMonths: { [key: string]: number } = Object.fromEntries(
    Array.from({ length: monthsBack }, (_, i) => {
      const date = new Date(currentDate.getFullYear(), currentDate.getMonth() - i, 1);
      return [getMonthYearKey(date), 0];
    })
  );

  data.forEach(item => {
    const apiItem = isLegacySalesStatistic(item) ? toApiSalesStatistic(item) : item;

    if (!apiItem.Day) return;
    const dayString = apiItem.Day.toString();
    const date = new Date(
      parseInt(dayString.slice(0, 4)), // year
      parseInt(dayString.slice(4, 6)) - 1 // month (0-indexed)
    );
    if (date >= monthsAgo && date <= currentDate) {
      lastMonths[getMonthYearKey(date)] += apiItem.Quantity ?? 0;
    }
  });

  const currentMonthYearKey = getMonthYearKey(currentDate);
  const daysInCurrentMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0).getDate();
  const daysElapsed = currentDate.getDate();

  // normalize data for current month
  if (lastMonths[currentMonthYearKey] > 0) {
    lastMonths[currentMonthYearKey] = Math.round(
      (lastMonths[currentMonthYearKey] / daysElapsed) * daysInCurrentMonth
    );
  }

  return Object.keys(lastMonths)
    .sort((a, b) => new Date(`1 ${a}`).getTime() - new Date(`1 ${b}`).getTime())
    .map(month => ({
      "Month": monthsBack <= 12 ? month.slice(0, 3) : month,
      "Units Sold": lastMonths[month]
    }));
}
